import React, { Fragment } from "react";
import { ArticleSection } from "../components/Home/ArticleSection";
// import { Carousel } from "../components/Home/Carousel";
import { HeroSection } from "../components/Home/HeroSection";
import { Member } from "../components/Home/Member";
import { EventsShowcase } from "../components/Home/EventsShowcase";
import { Services } from "../components/Home/Services";
import { Welcome } from "../components/Home/Welcome";
import { VesselOfTheWeek } from "../components/Home/VesselOfTheWeek";
import { BirthdayCTA } from "../components/Home/BirthdayCTA";
import { SectionErrorBoundary } from "../components/Global/SectionErrorBoundary";
import { BackToTop } from "../templates/BackToTop";
import { Map } from "../components/Global/Map";

export const Home = () => {
  return (
    <Fragment>
      <HeroSection />
      {/* <Carousel /> */}
      <Welcome />
      <SectionErrorBoundary>
        <VesselOfTheWeek />
      </SectionErrorBoundary>
      <BirthdayCTA />
      <Services />
      <SectionErrorBoundary>
        <EventsShowcase />
      </SectionErrorBoundary>
      <SectionErrorBoundary>
        <ArticleSection />
      </SectionErrorBoundary>
      <Member />
      <Map />

      <BackToTop />
    </Fragment>
  );
};
